export const assignmentEntryType = {
  imageStack: 1,
  pdf: 2,
  video: 3,
  audio: 4,
  comic: 5,
};
